import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { MuiTextField, MuiButton, Message } from '../../../../../components'
import adminTool from '../../../../../services/adminTool.service'
// import { useGlobalStore } from '../../../../../store'
import { OuterWrapper } from './style'
import { consoleLog, isValidEmail, getObjectAsArray } from '../../../../../util'

const Add = ({ onChange }) => {
  // const { company } = useGlobalStore()
  const initialFormObj = {
    emailAddress: ''
  }

  const form = useRef()
  const [formData, setFormData] = useState(initialFormObj)
  const [messages, setMessages] = useState(null)
  const [loading, setLoading] = useState(false)

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()
    const obj = {
      emailAddress: formData?.emailAddressInput?.trim() || null
    }

    if (obj.emailAddress.toLowerCase() !== 'all') {
      if (!isValidEmail(obj.emailAddress)) {
        setMessages({ type: 'error', msg: isValidEmail(obj.emailAddress, 'msg') })
        return false
      }
    }

    setLoading(true)
    // const payload = { organizationId: company?.OrganizationId, emailAddress: obj.emailAddress }
    const payload = { emailAddress: obj.emailAddress }
    await adminTool.getAdminUserLogApi(payload)
      .then(resp => {
        // consoleLog('SAL > resp ------------------------------- ', resp)
        onChange(getObjectAsArray(resp))
        resetForm()
        setLoading(false)
      })
      .catch(err => {
        consoleLog('err ', err)
        setMessages({ type: 'error', msg: 'Not a valid Email ID' })
        setLoading(false)
      })
  }

  const resetForm = () => {
    setFormData(initialFormObj)
    setMessages({ type: 'error', msg: '' })
  }

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload}>
        <Grid container spacing={2}>
          <Grid item xs={12} style={{ justifyContent: 'left', display: 'flex' }}>
            <MuiTextField
              name='emailAddress'
              placeholder='Enter Email Address'
              label='Email Address'
              onChange={(e) => onChangeHandler('emailAddressInput', e.target.value)}
              variant='standard'
              value={formData?.emailAddressInput || ''}
              style={{ width: '350px', marginRight: '10px' }}
            />
            <MuiButton
              onClick={submitPayload}
              type='submit'
              color='primary'
              variant='contained'
              disabled={loading}
            >
              Check Activity
            </MuiButton>
          </Grid>
          <Grid item xs={12}>
            <Message align='left' type={messages?.type}>{messages?.msg || ''}</Message>
          </Grid>
        </Grid>
      </form>
    </OuterWrapper>
  )
}

Add.propTypes = {
  onChange: PropTypes.func
}

export default Add
